import { c as _c } from "react/compiler-runtime";
import { postEntitiesByFpIdAgentsExecutionByIdOptions } from '@onefootprint/fetch-dashboard';
import type { AgentRunOutput, AgentRunOutputDocumentExtraction, PiiJsonValue, UserTimeline, UserTimelineEventAgentExecution } from '@onefootprint/request-types/dashboard';
import { useQueries } from '@tanstack/react-query';
import useCurrentEntityTimeline from '@/entity/hooks/use-current-entity-timeline';
import useEntityId from '@/entity/hooks/use-entity-id';
const isAgentExecutionEvent = (event: UserTimeline['event']): event is UserTimelineEventAgentExecution => {
  return event.kind === 'agent_execution';
};
const isDocumentExtraction = (output: AgentRunOutput): output is AgentRunOutputDocumentExtraction => 'agentKind' in output && output.agentKind === 'document_extraction';
const useAgentExtractionResult = documentIdentifier => {
  const $ = _c(15);
  const fpId = useEntityId();
  const {
    data: timeline
  } = useCurrentEntityTimeline();
  let t0;
  let t1;
  if ($[0] !== documentIdentifier || $[1] !== fpId || $[2] !== timeline) {
    const agentExecutionEvents = timeline?.filter(t2 => {
      const {
        event
      } = t2;
      return isAgentExecutionEvent(event) && event.data.kind === "document_extraction" && event.data.documentIdentifier === documentIdentifier;
    });
    const agentExecutionIds = agentExecutionEvents ? agentExecutionEvents.map(_temp) : [];
    t1 = useQueries;
    let t3;
    if ($[5] !== fpId) {
      t3 = id => ({
        ...postEntitiesByFpIdAgentsExecutionByIdOptions({
          path: {
            fpId,
            id
          }
        })
      });
      $[5] = fpId;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t0 = agentExecutionIds.map(t3);
    $[0] = documentIdentifier;
    $[1] = fpId;
    $[2] = timeline;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[7] !== t0) {
    t2 = {
      queries: t0
    };
    $[7] = t0;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const queries = t1(t2);
  let t3;
  let t4;
  if ($[9] !== queries) {
    const extractions = queries.map(_temp2).filter(_temp3).map(_temp4);
    t3 = extractions;
    t4 = extractions.some(_temp5);
    $[9] = queries;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = {
      extractions: t3,
      hasExtractionData: t4
    };
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default useAgentExtractionResult;
function _temp(t0) {
  const {
    event: event_0
  } = t0;
  return (event_0 as UserTimelineEventAgentExecution).data.id;
}
function _temp2(query) {
  return query.data;
}
function _temp3(data) {
  return !!data && isDocumentExtraction(data);
}
function _temp4(data_0) {
  return data_0.extraction as PiiJsonValue;
}
function _temp5(extraction) {
  return Object.keys(extraction).length > 0;
}